module.exports = __webpack_public_path__ + "static/Q1_2023_Investor_call_Dial-in_information-fcb4daa2221fd291b2f9ac01ba992ae3.pdf";